import { Stack } from '@mui/material';

import _ from 'lodash';

import { appFormUtil } from 'modules/common';

import { StyledTextField } from 'modules/components/layer01';
import React from 'react';



export type ProjectInstallationsFieldsProps<T extends object, K extends keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldNames: K[];
};
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object, K extends keyof T> (props: ProjectInstallationsFieldsProps<T, K>) => {
  const namedAreasProp = __isPropName<T, K>('namedAreasInProject', props.fieldNames);

  if (namedAreasProp) {
    const namedAreas = props.form.formState[namedAreasProp];

    if (_.isArray(namedAreas)) {
      return (
        <Stack
          rowGap='1.5rem'
          direction='column'
        >
          {
            namedAreas.map((node, i) => {
              if (
                node['areaName'] === 'roof'
                || node['areaName'] === 'exterior'
                || node['areaName'] === 'interior'
              ) {
                return <></>;
              }
              return (
                <StyledTextField.FC
                  key={i}
                  label={__formatLabel(node['areaName'])}
                  value={node['displayName']}
                  onChange={(e) => {
                    props.form.dispatch({
                      type: 'UPDATE_ARRAY_ITEM',
                      payload: {
                        identifier: 'id',
                        key: namedAreasProp as keyof appFormUtil.IArrayFields<T> & string,
                        value: {
                          ...node,
                          displayName: e.target.value
                        }
                      }
                    });
                  }}
                />
              );
            })
          }


        </Stack>
      );
    }
  }
  return <></>;
};

function __isPropName<T extends object, K extends keyof T>(propName: unknown, properties: K[]) {
  const exists = properties.find((node) => node === propName);
  return exists;
}


function __formatLabel(node: string | number | symbol): string {
  return _.snakeCase(node.toString() ?? '')
    .replace(/_/gm, ' ')
    .split(' ')
    .map((r) => _.upperFirst(r))
    .join(' ');
}
